module.exports = __webpack_public_path__ + "static/media/users-green.edc113a4.svg";